export const ADMIN_BASE_PATH = "/admin";
export const LOGIN_PATH = "/login";

export const LOGOUT_PATH = "/logout";
export const ACCESS_DENIED_PATH = "/access-denied";
export const HOME_PATH = "/";

export const DASHBOARD_PATH = "/dashboard";
export const USER_SETTINGS_PATH = DASHBOARD_PATH + "/user-settings";
export const USER_DETAILS_FORM_PATH = USER_SETTINGS_PATH + "/details";
export const AVATAR_IMAGE_FORM_PATH = USER_SETTINGS_PATH + "/avatar";
export const FRIENDS_INDEX_PATH = "/friends";
export const ADD_FRIEND_PATH = FRIENDS_INDEX_PATH + "/add";
export const CLAIM_FRIENDSHIP_PATH = FRIENDS_INDEX_PATH + "/claim";
export const FRIEND_STATISTICS_PATH = FRIENDS_INDEX_PATH + "/$playerId/statistics";
export const TEAMS_BASE_PATH = FRIENDS_INDEX_PATH + "/teams";
export const CREATE_TEAM_PATH = TEAMS_BASE_PATH + "/create";
export const TEAM_DETAILS_PATH = TEAMS_BASE_PATH + "/$teamId";
export const EDIT_TEAM_PATH = TEAM_DETAILS_PATH + "/edit";

export const GAME_SESSIONS_INDEX_PATH = "/game-sessions";
export const NEW_GAME_SESSION_PATH = "/game-session";
export const CREATE_GAME_SESSION_PATH = NEW_GAME_SESSION_PATH + "/create";

export const PLAYERS_STATISTICS_PATH = "/statistics";
export const RECORDS_PATH = "/records";
export const RECORDS_PLAYER_STATISTICS_PATH = RECORDS_PATH + "/$playerId/statistics";

export const GAME_SESSION_DETAILS_PATH = "/game-session/$gameSessionId";
export const GAME_SESSION_WATCH_PATH = GAME_SESSION_DETAILS_PATH;
export const GAME_SESSION_SCORE_TAKING_BASE_PATH = GAME_SESSION_DETAILS_PATH + "/score-taking";
export const ADD_TIEBREAK_WIN_PATH = GAME_SESSION_SCORE_TAKING_BASE_PATH + "/tiebreak-win";
export const FINISH_GAME_SESSION_PATH = GAME_SESSION_SCORE_TAKING_BASE_PATH + "/finish";
export const GAME_AND_SESSION_ACTIONS_PATH = GAME_SESSION_SCORE_TAKING_BASE_PATH + "/session-actions";
export const PRESENTER_CONTROL_PATH = GAME_SESSION_SCORE_TAKING_BASE_PATH + "/presenter";

export const GAME_BASE_PATH = GAME_SESSION_SCORE_TAKING_BASE_PATH + "/games";
export const CREATE_GAME_PATH = GAME_BASE_PATH + "/create";
export const GAME_SESSION_GAME_DETAILS_PATH = GAME_BASE_PATH + "/$gameId";
export const CREATE_ROUND_SCORE_PATH = GAME_SESSION_GAME_DETAILS_PATH + "/rounds";
export const DELETE_ROUND_SCORE_PATH = CREATE_ROUND_SCORE_PATH + "/delete";

export const DEV_BASE_PATH = "/dev";
export const SCORE_TAKING_DEBUG_PATH = DEV_BASE_PATH + "/score-taking";
export const SCORE_TAKING_DEBUG_PREVIEW_PATH = SCORE_TAKING_DEBUG_PATH + "/preview";
export const PRESENTER_DEBUG_PATH = DEV_BASE_PATH + "/presenter";
export const PRESENTER_DEBUG_PREVIEW_PATH = PRESENTER_DEBUG_PATH + "/preview";
export const PRESENTER_CONFIGURATOR_PATH = DEV_BASE_PATH + "/presenter-configurator";
export const STATS_DEBUG_PATH = DEV_BASE_PATH + "/stats";
export const STATS_DEBUG_PREVIEW_PATH = STATS_DEBUG_PATH + "/preview";
export const BUTTONS_PREVIEW_PATH = DEV_BASE_PATH + "/buttons";
export const SET_PASSWORD_PATH = "/set-password/$token";
export const RESET_PASSWORD_PATH = "/reset-password";
